import moment from "moment";

export const formatDate = (dateVal: Date) => {
  return moment(dateVal).format("DD/MM/YYYY HH:mm:ss");
};

export const formatDateSince = (dateVal: Date) => {
  const now = moment();
  const then = moment(dateVal);
  const duration = moment.duration(now.diff(then));

  if (duration.asDays() >= 1) {
    return formatDate(dateVal);
  }

  return then.fromNow();
};
